import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import {ToggleButton} from "primereact/togglebutton";
import {InputNumber} from "primereact/inputnumber";
import RanglisteMarkerComponent from "../liga/RanglisteMarkerComponent";
import {InputTextarea} from "primereact/inputtextarea";
import {TabPanel, TabView} from "primereact/tabview";
import {SelectButton} from "primereact/selectbutton";
import {TOURNAMENTMODUS} from "../../../constants/tournamentModus";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import TurnierSponsorenTabPanel from "./tabs/TurnierSponsorenTabPanel";
import TurnierAdminTabPanel from "./tabs/TurnierAdminTabPanel";
import LigaAktionenComponent from "./tabs/LigaAktionenComponent";
import {TOURNAMENTSYSTEMS} from "../../../constants/tournamentSystems";
import TournamentX01Area from "./TournamentX01Area";
import TournamentCricketArea from "./TournamentCricketArea";
import KODKOX01VerwaltenArea from "./verwalten/KODKOX01VerwaltenArea";
import KODKOCricketVerwaltenArea from "./verwalten/KODKOCricketVerwaltenArea";
import TurnierQRCode from "../liga/TurnierQRCode";
import TurnierKratzerTabPanel from "./tabs/TurnierKratzerTabPanel";
import BestleistungenDialog from "./BestleistungenDialog";
import RanglisteComponent from "../rangliste/RanglisteComponent";
import RanglisteProfilesComponent from "../rangliste/RanglisteProfilesComponent";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import InfoDialogEventNichtVeroeffentlichen from "../../general/InfoDialogEventNichtVeroeffentlichen";
import DHDialog from "../../general/DHDialog";
import DHDateTimePicker from "../../general/DHDateTimePicker";
import DHDefaultDrawer from "../../general/DHDefaultDrawer";
import DHSwitch from "../../general/DHSwitch";
import DHNumberTextField from "../../general/DHNumberTextField";
import EventVeranstalterAusrichterDatenComp from "./EventVeranstalterAusrichterDatenComp";
import EventVeranstalterZusatzdatenComp from "./EventVeranstalterZusatzdatenComp";
import DHTextFieldSmall from "../../general/DHTextFieldSmall";
import DHButtonDefault from "../../general/DHButtonDefault";
import DHButtonProgress from "../../general/DHButtonProgress";
import SaveIcon from "@mui/icons-material/Save";
import {PickList} from "primereact/picklist";
import {
    getSchweizerSystemSortierungBisher,
    SCHWEIZER_SYSTEM_SORTIERUNG,
    SCHWEIZER_SYSTEM_SORTIERUNG_STANDARD
} from "../../../constants/schweizerSystemSortierung";

function TurnierVerwaltenDialog({tournamentId, propEventOperatorId, callBackOnClose, callBackRefresh, callBackOnDelete}) {

    const darttypes = [
        {name: 'Steeldarts', code: 'STEELDARTS'},
        {name: 'E-Dart', code: 'EDART'},
        {name: 'Gemischt', code: 'GEMISCHT'},
    ];

    const turniersystemsAuswahl = [
        {name: 'KO Turnier', value: TOURNAMENTSYSTEMS.EINFACHERKO.id},
        {name: 'DKO Turnier', value: TOURNAMENTSYSTEMS.DOPPELTERKO.id},
        {name: 'Gruppe -> KO Turnier', value: TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id},
        {name: 'Gruppe -> DKO Turnier', value: TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id},
        {name: 'Round Robin', value: TOURNAMENTSYSTEMS.ROUND_ROBIN.id},
        {name: 'Kratzer', value: TOURNAMENTSYSTEMS.KRATZER.id},
        {name: 'Schweizer System', value: TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id},
        {name: 'Any Games', value: TOURNAMENTSYSTEMS.ANY_GAMES.id},
    ];

    let [tournament, setTournament] = useState(undefined);

    let [admins, setAdmins] = useState([]);

    let [showBestleistungenDialog, setShowBestleistungenDialog] = useState(false);

    let [eventOperatorId, setEventOperatorId] = useState(propEventOperatorId);
    let [sponsoren, setSponsoren] = useState([]);

    let [tournamentSystem, setTournamentSystem] = useState(undefined);

    let [working, setWorking] = useState(false);
    let [gameType, setGameType] = useState(eventOperatorId !== null && eventOperatorId !== undefined ? "x01" : undefined);
    let [id, setId] = useState(undefined);
    let [gruppeFolgeModusId, setGruppeFolgeModusId] = useState(undefined);
    let [turnierstatus, setTurnierstatus] = useState(undefined);
    let [bezeichnung, setBezeichnung] = useState("");
    let [bezeichnungShort, setBezeichnungShort] = useState("");
    let [kennwort, setKennwort] = useState("");
    let [maximaleAnzahlTeilnehmer, setMaximaleAnzahlTeilnehmer] = useState(undefined);
    let [minimaleAnzahlTeilnehmer, setMinimaleAnzahlTeilnehmer] = useState(undefined);
    let [beginn, setBeginn] = useState(undefined);
    let [anmeldeende, setAnmeldeende] = useState(undefined);
    let [anzeigenAb, setAnzeigenAb] = useState(undefined);
    let [doppelturnier, setDoppelturnier] = useState(false);
    let [dyp, setDyp] = useState(false);
    let [averageObergrenze, setAverageObergrenze] = useState(undefined);
    let [urkundendruck, setUrkundendruck] = useState(false);
    let [sollVomSystemGestartetWerden, setSollVomSystemGestartetWerden] = useState(false);
    let [bezahlung, setBezahlung] = useState(false);
    let [bezahlungbetrag, setBezahlungbetrag] = useState("");
    let [mailtext, setMailtext] = useState("");
    let [homepage, setHomepage] = useState("");
    let [socialmedia, setSocialmedia] = useState("");
    let [austragungsortBezeichnung, setAustragungsortBezeichnung] = useState("");
    let [austragungsortStrasse, setAustragungsortStrasse] = useState("");
    let [austragungsortPLZ, setAustragungsortPLZ] = useState("");
    let [austragungsortOrt, setAustragungsortOrt] = useState("");
    let [austragungsortEmail, setAustragungsortEmail] = useState("");
    let [austragungsortTelefon, setAustragungsortTelefon] = useState("");
    let [publishTournament, setPublishTournament] = useState(true);
    // sobald der EventOperator nicht gesetzt ist, handelt es sich um keinen Veranstalter somit um einen Onlineveranstalter. Dieser kann nur Online spielen.
    let [online, setOnline] = useState(eventOperatorId === null || eventOperatorId === undefined);
    let [scoringWithDarthelfer, setScoringWithDarthelfer] = useState(true);
    let [anwesenheitspruefungScorer, setAnwesenheitspruefungScorer] = useState(false);
    let [dartType, setDartType] = useState(darttypes[0]);
    let [registrationAllowed, setRegistrationAllowed] = useState(true);
    let [deleteUnconfirmedRegistrations, setDeleteUnconfirmedRegistrations] = useState(true);
    let [participantsMailConfirmation, setParticipantsMailConfirmation] = useState(true);
    let [rangliste, setRangliste] = useState(false);
    let [ranglistemarkers, setRanglistemarkers] = useState([]);
    let [beschreibung, setBeschreibung] = useState("");
    let [auslosungVonHand, setAuslosungVonHand] = useState(false);
    let [anzahlSpielerGold, setAnzahlSpielerGold] = useState(undefined);
    let [anzahlSpielerSilber, setAnzahlSpielerSilber] = useState(undefined);
    let [anzahlSpielerBronze, setAnzahlSpielerBronze] = useState(undefined);
    let [anzahlRunden, setAnzahlRunden] = useState(undefined);
    let [punkteSieg, setPunkteSieg] = useState(3);
    let [punkteUnentschieden, setPunkteUnentschieden] = useState(1);
    let [punkteVerloren, setPunkteVerloren] = useState(0);
    let [punkteBeiFreilos, setPunkteBeiFreilos] = useState(3);
    let [schweizerSystemSortierung, setSchweizerSystemSortierung] = useState(SCHWEIZER_SYSTEM_SORTIERUNG_STANDARD);
    let [ranglisteId, setRanglisteId] = useState(undefined);
    let [ranglisteProfileId, setRanglisteProfileId] = useState(undefined);
    let [ranglisteProfileIdSilber, setRanglisteProfileIdSilber] = useState(undefined);
    let [ranglisteProfileIdBronze, setRanglisteProfileIdBronze] = useState(undefined);
    let [ranglisteProfileIdGruppe, setRanglisteProfileIdGruppe] = useState(undefined);

    let [gewinnerseiteSets, setGewinnerseiteSets] = useState(undefined);
    let [gewinnerseiteBestToLegs, setGewinnerseiteBestToLegs] = useState(undefined);
    let [gewinnerseiteFirstToLegs, setGewinnerseiteFirstToLegs] = useState(undefined);
    let [gewinnerseiteModusId, setGewinnerseiteModusId] = useState(undefined);
    let [gewinnerseiteStartpunkte, setGewinnerseiteStartpunkte] = useState(undefined);
    let [gewinnerseiteZufallszahlen, setGewinnerseiteZufallszahlen] = useState(undefined);
    let [gewinnerseiteZufallszahlenJedesLeg, setGewinnerseiteZufallszahlenJedesLeg] = useState(undefined);
    let [gewinnerseiteCutthroat, setGewinnerseiteCutthroat] = useState(undefined);

    let [verliererseiteSets, setVerliererseiteSets] = useState(undefined);
    let [verliererseiteFirstToLegs, setVerliererseiteFirstToLegs] = useState(undefined);
    let [verliererseiteModusId, setVerliererseiteModusId] = useState(undefined);
    let [verliererseiteStartpunkte, setVerliererseiteStartpunkte] = useState(undefined);
    let [verliererseiteZufallszahlen, setVerliererseiteZufallszahlen] = useState(undefined);
    let [verliererseiteZufallszahlenJedesLeg, setVerliererseiteZufallszahlenJedesLeg] = useState(undefined);
    let [verliererseiteCutthroat, setVerliererseiteCutthroat] = useState(undefined);

    let [finaleVerliererseiteMussZweiSpieleGewinnen, setFinaleVerliererseiteMussZweiSpieleGewinnen] = useState(false);
    let [spielUmPlatz3, setSpielUmPlatz3] = useState(false);
    let [playerWarteliste, setPlayerWarteliste] = useState(false);
    let [bestplatzierteNaechsteKommenWeiter, setbestplatzierteNaechsteKommenWeiter] = useState(false);
    let [aufnahmenBisBullen, setAufnahmenBisBullen] = useState(undefined);

    let [showPublishTournamentInfo, setShowPublishTournamentInfo] = useState(false);
    let [showDartTypeNotice, setShowDartTypeNotice] = useState(false);
    let [showGoldSilberRanglistenprofilNotice, setShowGoldSilberRanglistenprofilNotice] = useState(false);
    let [showStartzeitpunktNotice, setShowStartzeitpunktNotice] = useState(false);
    let [showMaxAverageNotice, setShowMaxAverageNotice] = useState(false);
    let [showKennwortNotice, setShowKennwortNotice] = useState(false);
    let [showRoundRobinGruppenNotice, setShowRoundRobinGruppenNotice] = useState(false);
    let [showBestplatzierteNaechteKommtWeiter, setShowBestplatzierteNaechteKommtWeiter] = useState(false);
    let [showDypNotice, setShowDypNotice] = useState(false);
    let [showUrkundenNotice, setShowUrkundenNotice] = useState(false);
    let [showRanglisteNotice, setShowRanglisteNotice] = useState(false);
    let [showStartTournamentNotice, setShowStartTournamentNotice] = useState(false);
    let [showGoldSilberBronzeNotice, setShowGoldSilberBronzeNotice] = useState(false);

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    function ladeTurnier(id) {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.tournament + "/ladekodko/" + id,
            json => {
                let tournament = json.tournamentDto;
                setTournament(tournament);
                setId(tournament.id);
                setGruppeFolgeModusId(tournament.gruppeFolgeModusId);
                setEventOperatorId(tournament.eventOperatorId);
                setRanglisteId(tournament.ranglisteId);
                setRanglisteProfileId(tournament.ranglisteProfileId);
                setRanglisteProfileIdSilber(tournament.ranglisteProfileIdSilber);
                setRanglisteProfileIdBronze(tournament.ranglisteProfileIdBronze);
                setRanglisteProfileIdGruppe(tournament.ranglisteProfileIdGruppe);
                setTurnierstatus(tournament.tournamentstatus);
                setBezahlung(tournament.bezahlung);
                setBezahlungbetrag(tournament.bezahlungBetrag);
                setMailtext(tournament.mailtext);
                setOnline(tournament.online);
                setAustragungsortBezeichnung(tournament.austragungsortBezeichnung);
                setAustragungsortStrasse(tournament.austragungsortStrasse);
                setAustragungsortPLZ(tournament.austragungsortPLZ);
                setAustragungsortOrt(tournament.austragungsortOrt);
                setAustragungsortTelefon(tournament.telefon);
                setAustragungsortEmail(tournament.email);
                setSocialmedia(tournament.socialmedia);
                setHomepage(tournament.homepage);
                setParticipantsMailConfirmation(tournament.participantsMailConfirmation);
                setRegistrationAllowed(tournament.registrationAllowed);
                setDeleteUnconfirmedRegistrations(tournament.deleteUnconfirmedRegistrations);
                setPublishTournament(tournament.publishTournament);
                setScoringWithDarthelfer(tournament.scoringWithDarthelfer);
                setAnwesenheitspruefungScorer(tournament.anwesenheitspruefungScorer === true);
                if( tournament.dartType === null || tournament.dartType === undefined) {
                    setDartType(darttypes[0]);
                } else {
                    let tmpDartType = darttypes[0];
                    for (const tmp of darttypes) {
                        if( tmp.code === tournament.dartType) {
                            tmpDartType = tmp;
                        }
                    }
                    setDartType(tmpDartType);
                }
                setGameType(tournament.gameType);
                setBezeichnung(tournament.bezeichnung);
                setBezeichnungShort(tournament.bezeichnungShort);
                setTournamentSystem(tournament.turniersystem);
                setAuslosungVonHand(tournament.auslosungVonHand);
                setAnzahlSpielerGold(tournament.anzahlSpielerGold);
                setAnzahlSpielerSilber(tournament.anzahlSpielerSilber);
                setAnzahlSpielerBronze(tournament.anzahlSpielerBronze);
                setAnzahlRunden(tournament.anzahlRunden);
                setPunkteSieg(tournament.punkteSieg !== null && tournament.punkteSieg !== undefined ? tournament.punkteSieg : 3);
                setPunkteUnentschieden(tournament.punkteUnentschieden !== null && tournament.punkteUnentschieden !== undefined ? tournament.punkteUnentschieden : 1);
                setPunkteVerloren(tournament.punkteVerloren !== null && tournament.punkteVerloren !== undefined ? tournament.punkteVerloren : 0);
                setPunkteBeiFreilos(tournament.punkteBeiFreilos !== null && tournament.punkteBeiFreilos !== undefined ? tournament.punkteBeiFreilos : 3);
                setSchweizerSystemSortierung(tournament.schweizerSystemSortierung !== null && tournament.schweizerSystemSortierung !== undefined ?
                    tournament.schweizerSystemSortierung : getSchweizerSystemSortierungBisher(tournament.buchholzWertung));
                setbestplatzierteNaechsteKommenWeiter(tournament.bestplatzierteNaechsteKommenWeiter)
                setAufnahmenBisBullen(tournament.aufnahmenBisBullen !== null ? tournament.aufnahmenBisBullen : undefined);
                if (tournament.beginn !== undefined && tournament.beginn !== null) {
                    setBeginn(tournament.beginn);
                }
                setBeschreibung(tournament.beschreibung);
                setKennwort(tournament.kennwort);
                setMinimaleAnzahlTeilnehmer(tournament.minAnzahlTeilnehmer);
                setMaximaleAnzahlTeilnehmer(tournament.maxAnzahlTeilnehmer);
                setAverageObergrenze(tournament.averageObergrenze);
                if (tournament.anmeldeende !== undefined && tournament.anmeldeende !== null) {
                    setAnmeldeende(tournament.anmeldeende);
                }
                if (tournament.anzeigenAb !== undefined && tournament.anzeigenAb !== null) {
                    setAnzeigenAb(tournament.anzeigenAb);
                }
                setSollVomSystemGestartetWerden(tournament.sollVomSystemGestartetWerden);
                setDoppelturnier(tournament.doppelturnier);
                setDyp(tournament.dyp);
                setUrkundendruck(tournament.urkunden);
                setFinaleVerliererseiteMussZweiSpieleGewinnen(tournament.finaleVerliererseiteMussZweiSpieleGewinnen);
                setSpielUmPlatz3(tournament.spielUmPlatz3);
                setPlayerWarteliste(tournament.playerWarteliste);
                setRangliste(tournament.rangliste);
                setRanglistemarkers(tournament.ranglistemarkers);
                let adminsNachDemLaden = [];
                for (const tmpAdmin of tournament.administratoren) {
                    adminsNachDemLaden.push(tmpAdmin.userId);
                }
                setAdmins(adminsNachDemLaden);
                let sponsorenNachDemLaden = [];
                for (const tmpSponsor of tournament.tournamentSponsorenEntities) {
                    sponsorenNachDemLaden.push(tmpSponsor.sponsorEntity.id)
                }
                setSponsoren(sponsorenNachDemLaden);
                let tournamentModusEntities = tournament.tournamentModusEntities;
                let modusKratzer = tournamentModusEntities.find(modusEntity => modusEntity.modusTyp === "kratzer");
                if (modusKratzer !== null && modusKratzer !== undefined) {
                    setGewinnerseiteSets(modusKratzer.sets);
                    setGewinnerseiteStartpunkte(modusKratzer.startpunkte);
                    setGewinnerseiteFirstToLegs(modusKratzer.firstToLegs);
                    setGewinnerseiteBestToLegs(modusKratzer.bestOfLegs);
                    setGewinnerseiteModusId(modusKratzer.modusid);
                }
                let modusAnyGames = tournamentModusEntities.find(modusEntity => modusEntity.modusTyp === "anygames");
                if (modusAnyGames !== null && modusAnyGames !== undefined) {
                    setGewinnerseiteSets(modusAnyGames.sets);
                    setGewinnerseiteStartpunkte(modusAnyGames.startpunkte);
                    setGewinnerseiteFirstToLegs(modusAnyGames.firstToLegs);
                    setGewinnerseiteBestToLegs(modusAnyGames.bestOfLegs);
                    setGewinnerseiteModusId(modusAnyGames.modusid);
                }
                let modusGruppenturnier = tournamentModusEntities.find(modusEntity => modusEntity.modusTyp === "gruppenturnier");
                if (modusGruppenturnier !== null && modusGruppenturnier !== undefined) {
                    setGewinnerseiteSets(modusGruppenturnier.sets);
                    setGewinnerseiteStartpunkte(modusGruppenturnier.startpunkte);
                    setGewinnerseiteFirstToLegs(modusGruppenturnier.firstToLegs);
                    setGewinnerseiteBestToLegs(modusGruppenturnier.bestOfLegs);
                    setGewinnerseiteModusId(modusGruppenturnier.modusid);
                    setGewinnerseiteZufallszahlen(modusGruppenturnier.zufallszahlen);
                    setGewinnerseiteZufallszahlenJedesLeg(modusGruppenturnier.zufallszahlenjedesleg);
                    setGewinnerseiteCutthroat(modusGruppenturnier.cutthroat);
                }
                let modusVerliererseite = tournamentModusEntities.find(modusEntity => modusEntity.modusTyp === "verliererseite");
                if (modusVerliererseite !== null && modusVerliererseite !== undefined) {
                    setVerliererseiteSets(modusVerliererseite.sets);
                    setVerliererseiteStartpunkte(modusVerliererseite.startpunkte);
                    setVerliererseiteFirstToLegs(modusVerliererseite.firstToLegs);
                    setVerliererseiteModusId(modusVerliererseite.modusid);
                    setVerliererseiteZufallszahlen(modusVerliererseite.zufallszahlen);
                    setVerliererseiteZufallszahlenJedesLeg(modusVerliererseite.zufallszahlenjedesleg);
                    setVerliererseiteCutthroat(modusVerliererseite.cutthroat);
                }
                let modusGewinnerseite = tournamentModusEntities.find(modusEntity => modusEntity.modusTyp === "gewinnerseite");
                if (modusGewinnerseite !== null && modusGewinnerseite !== undefined) {
                    setGewinnerseiteSets(modusGewinnerseite.sets);
                    setGewinnerseiteStartpunkte(modusGewinnerseite.startpunkte);
                    setGewinnerseiteFirstToLegs(modusGewinnerseite.firstToLegs);
                    setGewinnerseiteModusId(modusGewinnerseite.modusid);
                    setGewinnerseiteZufallszahlen(modusGewinnerseite.zufallszahlen);
                    setGewinnerseiteZufallszahlenJedesLeg(modusGewinnerseite.zufallszahlenjedesleg);
                    setGewinnerseiteCutthroat(modusGewinnerseite.cutthroat);
                }
                setShowPublishTournamentInfo(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    useEffect(() => {
        if (tournamentId === null || tournamentId === undefined) {
            return;
        }
        ladeTurnier(tournamentId);
    }, []);

    useEffect(() => {
        if(!publishTournament) {
            setShowPublishTournamentInfo(true);
        }
    }, [publishTournament]);

    function eventOperatorDatenVorbelegen() {
        setErrorMessage(undefined);

        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.eventoperator + "/byId/" + eventOperatorId,
            json => {
                setHomepage(json.homepage);
                setSocialmedia(json.socialmedia);
                setAustragungsortBezeichnung(json.austragungsortBezeichnung);
                setAustragungsortStrasse(json.austragungsortStrasse);
                setAustragungsortPLZ(json.austragungsortPLZ);
                setAustragungsortOrt(json.austragungsortOrt);
                setAustragungsortEmail(json.email);
                setAustragungsortTelefon(json.telefon);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Veranstalterdaten: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden der Veranstalterdaten: " + error.message);
            }
        );
    }

    function save() {
        setErrorMessage(undefined);
        if( isAustragungsortPflicht() && (isLeer(austragungsortPLZ) || isLeer(austragungsortOrt))) {
            setErrorMessage("Sofern das Event veröffentlicht wird, müssen PLZ und Ort des Austragungsorts (Reiter Veranstalter) gefüllt sein.");
            return;
        }
        if( (rangliste || (ranglisteId !== null && ranglisteId !== undefined)) && (bezeichnungShort === null || bezeichnungShort === undefined || bezeichnungShort === "")) {
            setErrorMessage("Kurzbezeichnung muss bei Rangliste gefüllt sein.");
            return;
        }
        if( eventOperatorId !== undefined && eventOperatorId !== null && bezahlung && bezahlungbetrag === "") {
            setErrorMessage("Sofern du Bezahlung gewählt hast, musst du auch einen Bezahlbetrag eingeben.");
            return;
        }
        setWorking(true);
        let isDKOModus = tournamentSystem === TOURNAMENTSYSTEMS.DOPPELTERKO.id;
        let modusArray = [];
        if (tournamentSystem === TOURNAMENTSYSTEMS.KRATZER.id) {
            modusArray.push({
                modusTyp: TOURNAMENTMODUS.KRATZER.id,
                gameType: gameType,
                modusid: gewinnerseiteModusId,
                sets: gewinnerseiteSets,
                firstToLegs: gewinnerseiteFirstToLegs,
                bestOfLegs: gewinnerseiteBestToLegs,
                startpunkte: gewinnerseiteStartpunkte,
            });
        } else if (tournamentSystem === TOURNAMENTSYSTEMS.ANY_GAMES.id) {
            modusArray.push({
                modusTyp: TOURNAMENTMODUS.ANY_GAMES.id,
                gameType: gameType,
                modusid: gewinnerseiteModusId,
                sets: gewinnerseiteSets,
                firstToLegs: gewinnerseiteFirstToLegs,
                bestOfLegs: gewinnerseiteBestToLegs,
                startpunkte: gewinnerseiteStartpunkte,
                zufallszahlen: gewinnerseiteZufallszahlen,
                zufallszahlenjedesleg: gewinnerseiteZufallszahlenJedesLeg,
                cutthroat: gewinnerseiteCutthroat
            });
        } else if (tournamentSystem === TOURNAMENTSYSTEMS.ROUND_ROBIN.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id) {
            modusArray.push({
                modusTyp: TOURNAMENTMODUS.GRUPPENTURNIER.id,
                gameType: gameType,
                modusid: gewinnerseiteModusId,
                sets: gewinnerseiteSets,
                firstToLegs: gewinnerseiteFirstToLegs,
                bestOfLegs: gewinnerseiteBestToLegs,
                startpunkte: gewinnerseiteStartpunkte,
                zufallszahlen: gewinnerseiteZufallszahlen,
                zufallszahlenjedesleg: gewinnerseiteZufallszahlenJedesLeg,
                cutthroat: gewinnerseiteCutthroat
            });
        } else {
            modusArray.push({
                modusTyp: TOURNAMENTMODUS.GEWINNERSEITE.id,
                gameType: gameType,
                modusid: gewinnerseiteModusId,
                sets: gewinnerseiteSets,
                firstToLegs: gewinnerseiteFirstToLegs,
                bestOfLegs: undefined,
                startpunkte: gewinnerseiteStartpunkte,
                zufallszahlen: gewinnerseiteZufallszahlen,
                zufallszahlenjedesleg: gewinnerseiteZufallszahlenJedesLeg,
                cutthroat: gewinnerseiteCutthroat
            });
            if (isDKOModus && (verliererseiteModusId !== undefined || verliererseiteSets !== undefined || verliererseiteFirstToLegs !== undefined || verliererseiteStartpunkte)) {
                modusArray.push({
                    modusTyp: TOURNAMENTMODUS.VERLIERERSEITE.id,
                    gameType: gameType,
                    modusid: verliererseiteModusId,
                    sets: verliererseiteSets,
                    firstToLegs: verliererseiteFirstToLegs,
                    bestOfLegs: undefined,
                    startpunkte: verliererseiteStartpunkte,
                    zufallszahlen: verliererseiteZufallszahlen,
                    zufallszahlenjedesleg: verliererseiteZufallszahlenJedesLeg,
                    cutthroat: verliererseiteCutthroat
                });
            }
        }

        let adminsZumSpeichern = [];
        for (const admin of admins) {
            adminsZumSpeichern.push({userId: admin});
        }

        let myPublishTournament;
        if( eventOperatorId === null || eventOperatorId === undefined) {
            // kein eventOperator, daher immer veröffentlichen
            myPublishTournament = true;
        } else {
            myPublishTournament =  publishTournament;
        }

        let data = {
            id: id, gameType: gameType, eventOperatorId: eventOperatorId,
            participantsMailConfirmation: participantsMailConfirmation,
            bezahlung: bezahlung,
            bezahlungBetrag: bezahlungbetrag,
            socialmedia: socialmedia,
            homepage: homepage,
            austragungsortBezeichnung: austragungsortBezeichnung,
            austragungsortStrasse: austragungsortStrasse,
            austragungsortPLZ: austragungsortPLZ,
            austragungsortOrt: austragungsortOrt,
            email: austragungsortEmail,
            telefon: austragungsortTelefon,
            mailtext: mailtext,
            registrationAllowed: registrationAllowed,
            deleteUnconfirmedRegistrations: deleteUnconfirmedRegistrations,
            publishTournament: myPublishTournament,
            scoringWithDarthelfer: scoringWithDarthelfer,
            anwesenheitspruefungScorer: scoringWithDarthelfer && anwesenheitspruefungScorer,
            dartType: dartType.code,
            online: online, bezeichnung: bezeichnung, bezeichnungShort: bezeichnungShort, beschreibung: beschreibung,
            beginn: beginn, anmeldeende: anmeldeende, anzeigenAb: anzeigenAb,
            kennwort: kennwort,
            turniersystem: tournamentSystem,
            maxAnzahlTeilnehmer: maximaleAnzahlTeilnehmer,
            minAnzahlTeilnehmer: minimaleAnzahlTeilnehmer,
            sollVomSystemGestartetWerden: sollVomSystemGestartetWerden,
            doppelturnier: doppelturnier, dyp: dyp, urkunden: urkundendruck,
            rangliste: rangliste, ranglistemarkers: ranglistemarkers,
            ranglisteId: ranglisteId,
            ranglisteProfileId: ranglisteProfileId,
            ranglisteProfileIdSilber: ranglisteProfileIdSilber,
            ranglisteProfileIdBronze: ranglisteProfileIdBronze,
            ranglisteProfileIdGruppe: ranglisteProfileIdGruppe,
            averageObergrenze: averageObergrenze,
            finaleVerliererseiteMussZweiSpieleGewinnen: finaleVerliererseiteMussZweiSpieleGewinnen,
            spielUmPlatz3: spielUmPlatz3,
            playerWarteliste: playerWarteliste,
            administratoren: adminsZumSpeichern,
            sponsorenZumSpeichern: sponsoren,
            tournamentModusEntities: modusArray,
            auslosungVonHand: auslosungVonHand,
            anzahlSpielerGold: anzahlSpielerGold,
            anzahlSpielerSilber: anzahlSpielerSilber,
            anzahlSpielerBronze: anzahlSpielerBronze,
            anzahlRunden: anzahlRunden,
            punkteSieg: punkteSieg !== null && punkteSieg !== undefined ? punkteSieg : 3,
            punkteUnentschieden: punkteUnentschieden !== null && punkteUnentschieden !== undefined ? punkteUnentschieden : 1,
            punkteVerloren: punkteVerloren !== null && punkteVerloren !== undefined ? punkteVerloren : 0,
            punkteBeiFreilos: punkteBeiFreilos !== null && punkteBeiFreilos !== undefined ? punkteBeiFreilos : 3,
            schweizerSystemSortierung: schweizerSystemSortierung,
            bestplatzierteNaechsteKommenWeiter: bestplatzierteNaechsteKommenWeiter,
            aufnahmenBisBullen: aufnahmenBisBullen,
        };
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.tournament + "/save",
            data,
            json => {
                ladeTurnier(json.id);
                setInfoMessage("Turnier wurde erfolgreich gespeichert.");
                callBackRefresh();
                setWorking(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Speichern: " + responseNotOk.message);
                setWorking(false);
            },
            error => {
                setErrorMessage("Fehler beim Speichern: " + error.message);
                setWorking(false);
            }
        );
    }


    function showSaveButton() {
        if (!bezeichnung || !beginn || !tournamentSystem) {
            return false;
        }
        if( eventOperatorId !== null && eventOperatorId !== undefined && (publishTournament === undefined || publishTournament === null)) {
            return false;
        }
        if (gameType === "x01") {
            if (tournamentSystem === TOURNAMENTSYSTEMS.EINFACHERKO.id) {
                return gewinnerseiteFirstToLegs && gewinnerseiteModusId && gewinnerseiteStartpunkte;
            } else if (tournamentSystem === TOURNAMENTSYSTEMS.DOPPELTERKO.id) {
                let gewinnerFelder = gewinnerseiteFirstToLegs && gewinnerseiteModusId && gewinnerseiteStartpunkte;
                let verliererFelder = verliererseiteFirstToLegs && verliererseiteModusId && verliererseiteStartpunkte;
                return gewinnerFelder && verliererFelder;
            } else if (tournamentSystem === TOURNAMENTSYSTEMS.ROUND_ROBIN.id ||
                tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id ||
                tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id ||
                tournamentSystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id ||
                tournamentSystem === TOURNAMENTSYSTEMS.ANY_GAMES.id ||
                tournamentSystem === TOURNAMENTSYSTEMS.KRATZER.id) {
                return (gewinnerseiteFirstToLegs || gewinnerseiteBestToLegs) && gewinnerseiteModusId && gewinnerseiteStartpunkte;
            } else {
                return false;
            }
        } else if (gameType === "cricket") {
            if (tournamentSystem === TOURNAMENTSYSTEMS.EINFACHERKO.id) {
                return gewinnerseiteFirstToLegs && gewinnerseiteZufallszahlen !== undefined && gewinnerseiteCutthroat !== undefined;
            } else if (tournamentSystem === TOURNAMENTSYSTEMS.DOPPELTERKO.id) {
                let gewinnerFelder = gewinnerseiteFirstToLegs && gewinnerseiteZufallszahlen !== undefined && gewinnerseiteCutthroat !== undefined;
                let verliererFelder = verliererseiteFirstToLegs && verliererseiteZufallszahlen !== undefined && verliererseiteCutthroat !== undefined;
                return gewinnerFelder && verliererFelder;
            } else if (tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id || tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id) {
                return (gewinnerseiteFirstToLegs || gewinnerseiteBestToLegs) && gewinnerseiteZufallszahlen !== undefined && gewinnerseiteCutthroat !== undefined;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // Punkte stehen immer an erster Stelle, die übrigen Kriterien sind frei sortierbar.
    // Die Sortierung ändert die Rangliste und damit die Paarungen, deshalb nur vor dem Start änderbar.
    const getSchweizerSystemSortierungArea = () => {
        const ohnePunkte = schweizerSystemSortierung.filter(id => id !== SCHWEIZER_SYSTEM_SORTIERUNG.PUNKTE.id);
        if (!istTurnierNeu()) {
            return <>
                {[SCHWEIZER_SYSTEM_SORTIERUNG.PUNKTE.id, ...ohnePunkte].map((id, index) =>
                    <div key={"key_sortierung_" + id}>{index + 1}. {SCHWEIZER_SYSTEM_SORTIERUNG[id].label}</div>
                )}
                <div style={{marginTop: 5, opacity: "0.6", fontSize: 10}}>
                    Die Sortierung kann nach dem Start des Turniers nicht mehr geändert werden.
                </div>
            </>
        }
        const target = ohnePunkte.map(id => SCHWEIZER_SYSTEM_SORTIERUNG[id]);
        const source = SCHWEIZER_SYSTEM_SORTIERUNG_STANDARD
            .filter(id => id !== SCHWEIZER_SYSTEM_SORTIERUNG.PUNKTE.id && !ohnePunkte.includes(id))
            .map(id => SCHWEIZER_SYSTEM_SORTIERUNG[id]);
        return <>
            <div style={{marginBottom: 5}}>1. {SCHWEIZER_SYSTEM_SORTIERUNG.PUNKTE.label} (fest)</div>
            <PickList dataKey="id" source={source} target={target} itemTemplate={(item) => <span>{item.label}</span>}
                      sourceHeader="Nicht verwendet" targetHeader="Danach sortieren nach"
                      sourceStyle={{height: 250}} targetStyle={{height: 250}}
                      onChange={(event) => setSchweizerSystemSortierung([SCHWEIZER_SYSTEM_SORTIERUNG.PUNKTE.id, ...event.target.map(item => item.id)])}
                      showSourceControls={false}/>
            <div style={{marginTop: 10}}>
                <DHButtonDefault label="Standard wiederherstellen" onClick={() => setSchweizerSystemSortierung(SCHWEIZER_SYSTEM_SORTIERUNG_STANDARD)}/>
            </div>
            <div style={{marginTop: 5, opacity: "0.6", fontSize: 10}}>
                Bei Punktgleichheit entscheiden die Kriterien rechts von oben nach unten. Beim direkten Vergleich zählen nur die Spiele
                der punktgleichen Spieler untereinander. Bei mehr als zwei Spielern nur, wenn jeder gegen jeden gespielt hat.
                Die Sortierung kann nach dem Start des Turniers nicht mehr geändert werden.
            </div>
        </>
    }

    function istTurnierNeu() {
        return turnierstatus === undefined || turnierstatus === null || turnierstatus === "neu";
    }

    function istTurnierGestartet() {
        return turnierstatus === "gestartet";
    }

    function istTurnierAbgeschlossen() {
        return turnierstatus === "abgeschlossen";
    }

    function isAustragungsortPflicht() {
        // ohne Veranstalter wird immer veröffentlicht, die Austragungsortdaten sind dann aber nicht erfassbar
        return eventOperatorId !== null && eventOperatorId !== undefined && publishTournament === true && !isFolgeturnier();
    }

    function isFolgeturnier() {
        // Gold-, Silber- und Bronze-Turnier werden aus einem Basisturnier erzeugt, dort wird kein Austragungsort gepflegt
        return tournament !== undefined && (tournament.goldTurnier === true || tournament.silberTurnier === true || tournament.bronzeTurnier === true);
    }

    function isLeer(wert) {
        return wert === null || wert === undefined || String(wert).trim() === "";
    }

    const dialogFooter = (
        <div>
            <DHButtonProgress working={working} icon={<SaveIcon/>}
                              ButtonSave label="Speichern"
                              style={{marginRight: 5}}
                              disabled={!showSaveButton()} onClick={() => save()}/>
        </div>
    );

    function getX01Area() {
        if (tournamentSystem === TOURNAMENTSYSTEMS.ROUND_ROBIN.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.ANY_GAMES.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id ||
            tournamentSystem === TOURNAMENTSYSTEMS.KRATZER.id) {
            return <>
                <TournamentX01Area showSets={true} showBestOfLegs={true} showPflichtfelder={true}
                                      sets={gewinnerseiteSets}
                                      firstToLegs={gewinnerseiteFirstToLegs}
                                      bestOfLegs={gewinnerseiteBestToLegs}
                                      modusId={gewinnerseiteModusId} startpunkte={gewinnerseiteStartpunkte}
                                      onSetsChanged={(sets) => setGewinnerseiteSets(sets)}
                                      onFirstToLegsChanged={(firstToLegs) => setGewinnerseiteFirstToLegs(firstToLegs)}
                                      onBestOfLegsChanged={(bestOfLegs) => setGewinnerseiteBestToLegs(bestOfLegs)}
                                      onModusIdChanged={(modusId) => setGewinnerseiteModusId(modusId)}
                                      onStartpunkteChanged={(startpunkte) => setGewinnerseiteStartpunkte(startpunkte)}
                                      aufnahmenBisBullen={aufnahmenBisBullen}
                                      onAufnahmenBisBullenChanged={(value) => setAufnahmenBisBullen(value)}
                                      bullenDisabled={istTurnierAbgeschlossen()}/>
                {(eventOperatorId !== undefined && (tournamentSystem === TOURNAMENTSYSTEMS.ROUND_ROBIN.id || tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id || tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id)) && <>
                    <div style={{marginTop:20}}>
                        <DHDefaultDrawer onClose={() => setShowRoundRobinGruppenNotice(false)} show={showRoundRobinGruppenNotice} title={"Hinweis"} children={
                            <div style={{padding: 20}}>
                                <div style={{marginBottom: 5}}>
                                    Wähle 'Ja' sobald du die Gruppen von Hand festlegen willst. Bei 'Nein' wird Darthelfer die Gruppen für dich automatisch erstellen und
                                    auslosen.
                                </div>
                            </div>
                        }/>
                        <div>
                            <DHSwitch id="id-auslosung-von-hand" value={auslosungVonHand} onChange={() => setAuslosungVonHand(!auslosungVonHand)}
                                label="Gruppen von Hand festlegen"/>
                            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                               onClick={(e) => setShowRoundRobinGruppenNotice(!showRoundRobinGruppenNotice)}/>
                        </div>
                    </div>
                </>
                }
                {(eventOperatorId !== undefined && !istTurnierAbgeschlossen() &&
                    (tournamentSystem === TOURNAMENTSYSTEMS.ROUND_ROBIN.id ||
                        tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id ||
                        tournamentSystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id ||
                        tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id)) && <>
                    <DHDefaultDrawer onClose={() => setShowGoldSilberBronzeNotice(false)} show={showGoldSilberBronzeNotice} title={"Hinweis"} children={
                        <div style={{padding: 20}}>
                            <div style={{marginBottom: 5}}>
                            Ein normales KO/DKO Turnier wird in Darthelfer 'Gold' genannt.<br/>
                                Bei einem Gruppenturnier oder Schweizer System mit anschließendem KO/DKO kannst du hier einstellen, welche Plätze in das Gold Turnier
                                weiterkommen. Stellst du hier z.B. 2 ein, kommen die ersten beiden Spieler in der Tabelle in das Gold Turnier.
                            </div>
                            <div style={{marginTop: 10}}>
                                Ein Lucky Loser Turnier wird in Darthelfer 'Silber' genannt.<br/>
                                Beim Starten des Silber-Turniers wirst du nach den Platzierungen gefragt, die in das Silber-Turnier gelost werden sollen.<br/>
                                Hier dient die Einstellung ausschließlich dazu, dass diese Platzierungen in der Tabelle markiert werden.<br/>
                                Beispiel: Du stellst 2 beim Gold-Turnier ein und 2 beim Silber-Turnier. Somit wird angezeigt, dass Platz 3 und 4 in das Silber-Turnier kommen.
                            </div>
                        </div>
                    }/>
                    <div style={{marginTop: 20}}>
                        <div>
                            <DHNumberTextField id="id-spieler-pro-gruppe-gold" value={anzahlSpielerGold} onChange={(value) => setAnzahlSpielerGold(value)}
                                               label="Anzahl Spieler pro Gruppe für Gold KO/DKO" min={1} width={300} required={true}/>
                            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                               onClick={(e) => setShowGoldSilberBronzeNotice(!showGoldSilberBronzeNotice)}/>
                        </div>
                        <div style={{marginTop: 5, opacity: "0.6", fontSize: 10}}>
                            Markierung der Platzierungen in der Tabelle.
                        </div>
                    </div>
                    {(tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id ||
                            tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id) && <>
                        <div style={{marginTop: 20}}>
                            <div>
                                <DHNumberTextField id="id-spieler-pro-gruppe-silber" value={anzahlSpielerSilber} onChange={(value) => setAnzahlSpielerSilber(value)}
                                                   label="Anzahl Spieler pro Gruppe für Silber KO/DKO" min={1} width={300} required={false}/>
                                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                   onClick={(e) => setShowGoldSilberBronzeNotice(!showGoldSilberBronzeNotice)}/>
                            </div>
                        </div>
                        <div style={{marginTop: 20}}>
                            <div>
                                <DHNumberTextField id="id-spieler-pro-gruppe-bronze" value={anzahlSpielerBronze} onChange={(value) => setAnzahlSpielerBronze(value)}
                                                   label="Anzahl Spieler pro Gruppe für Bronze KO/DKO" min={1} width={300} required={false}/>
                                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                   onClick={(e) => setShowGoldSilberBronzeNotice(!showGoldSilberBronzeNotice)}/>
                            </div>
                        </div>
                    </>
                    }
                </>
                }
                {eventOperatorId !== undefined && tournamentSystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id &&
                    <div style={{marginTop: 20}}>
                        <div>
                            <DHNumberTextField id="id-anzahl-runden" value={anzahlRunden} onChange={(value) => setAnzahlRunden(value)}
                                               label="Anzahl Runden die automatisch gestartet werden" min={1} width={300} required={false}/>
                        </div>
                        <div style={{marginTop: 5, opacity: "0.6", fontSize: 10}}>
                            Anzahl Runden die automatisch gestartet werden sollen. Kann beim Starten des Turniers ebenfalls gesetzt werden
                        </div>
                    </div>
                }
                {tournamentSystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id &&
                    <div style={{marginTop: 20}}>
                        <div style={{fontWeight: "bold", marginBottom: 10}}>Punktevergabe</div>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-sieg" variant="standard" value={punkteSieg} onChange={(text) => setPunkteSieg(text)} label="Sieg" width={100} min={0} max={100}
                                               disabled={istTurnierAbgeschlossen()}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-unentschieden" variant="standard" value={punkteUnentschieden} onChange={(text) => setPunkteUnentschieden(text)} label="Unentschieden" width={100} min={0} max={100}
                                               disabled={istTurnierAbgeschlossen()}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-verloren" variant="standard" value={punkteVerloren} onChange={(text) => setPunkteVerloren(text)} label="Verloren" width={100} min={0} max={100}
                                               disabled={istTurnierAbgeschlossen()}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-freilos" variant="standard" value={punkteBeiFreilos} onChange={(text) => setPunkteBeiFreilos(text)} label="Bei Freilos" width={100} min={0} max={100}
                                               disabled={istTurnierAbgeschlossen()}/>
                        </div>
                    </div>
                }
                {tournamentSystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id &&
                    <div style={{marginTop: 20}}>
                        <div style={{fontWeight: "bold", marginBottom: 10}}>Tabellensortierung</div>
                        {getSchweizerSystemSortierungArea()}
                    </div>
                }
                {(!istTurnierAbgeschlossen() && (tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id || tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id)) && <>
                    <div style={{marginTop: 20}}>
                        <DHDefaultDrawer onClose={() => setShowBestplatzierteNaechteKommtWeiter(false)} show={showBestplatzierteNaechteKommtWeiter} title={"Hinweis"} children={
                            <div style={{padding: 20}}>
                                <div style={{marginBottom: 5}}>
                                    Sobald du durch die Eingabe *Anzahl der Spieler pro Gruppe die Weiterkommen* keinen vollständingen
                                    z.B. 16er, 32er usw. KO-Baum gefüllt hast, <br/>
                                    kannst du mit diesem Schalter die bestplatzierten Nächsten (z.B. die bestplatzierten Dritten) weiterkommen lassen.<br/><br/>
                                    Diese Auswahl ergibt nur Sinn, sobald durch deine Gruppenzahl und Teilnehmer die Weiterkommen nicht sowieso ein z.B. 16er, 32er usw. KO-Baum entsteht.<br/><br/>
                                    WICHTIG '1'! Sofern du die Gruppenphase als DKO spielst, wird diese Einstellung keine Auswirkung haben.<br/><br/>
                                    WICHTIG '2'!<br/>
                                    Beispiel: 5 Gruppen, 2 kommen weiter und die Bestplatzierten.<br/>
                                    In diesem Fall würden 5 x 2 weiterkommen = 10 plus die bestplatzierten Dritten, dass wären alle Dritten. Somit gesamt 15 Spieler die Weiterkommen.<br/>
                                    Bei dieser Einstellung würde <b>nicht</b> auf die weiteren Bestplatzierten auf Platz 4 geschaut um den KO-Baum zu füllen. Es würde somit 1 Freilos geben.<br/>
                                    Deine Einstellung in diesem Fall sollte sein, dass 3 weiterkommen und die Bestplatzierten. Damit würden 5 x 3 = 15 plus der bestplatzierte 4. weiterkommen. Gesamt
                                    somit 16 Spieler die weiterkommen.<br/><br/>
                                    WICHTIG '3'!<br/>
                                    Bei der Berechnung des Bestplatzierten wird ein Sieg des Spielers mit 3 Punkten gewertet, ein Unentschieden mit 1 Punkt. Diese Punkte werden durch die Anzahl der
                                    Spiele
                                    geteilt. Somit ist die Berechnung auch bei unterschiedlichen Gruppengrößen und damit unterschiedliche Spieleanzahl gerecht.<br/>
                                    Beispiel:<br/>
                                    Spieler 1: 1 Siege, 1 Unentschieden und 3 Verloren = 0,8 Faktor<br/>
                                    Spieler 2: 1 Siege, 1 Unentschieden und 2 Verloren = 1,0 Faktor<br/>
                                    Spieler 3: 0 Siege, 2 Unentschieden und 2 Verloren = 0,5 Faktor<br/>
                                    Die Spieler würden nun in der Reihenfolge des Faktors berücksichtigt. Zuerst Spieler 2, dann Spieler 1 und zum Schluss Spieler 3.
                                </div>
                            </div>
                        }/>
                        <div>
                            <DHSwitch id="id-bestplatzierteNachete" label="Bestplatzierte Nächste kommen weiter ins Gold" value={bestplatzierteNaechsteKommenWeiter}
                                      onChange={() => setbestplatzierteNaechsteKommenWeiter(!bestplatzierteNaechsteKommenWeiter)}/>
                            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                               onClick={() => setShowBestplatzierteNaechteKommtWeiter(!showBestplatzierteNaechteKommtWeiter)}/>
                        </div>
                        <div style={{marginTop: 5, opacity: "0.6", fontSize: 10}}>
                            Diese Einstellung zu aktivieren macht nur Sinn, sofern es kein Silber-Turnier gibt.
                        </div>
                    </div>
                </>
                }
            </>
        }

        return <>
            <KODKOX01VerwaltenArea
                tournamentSystem={tournamentSystem}
                verliererseiteSets={verliererseiteSets}
                verliererseiteModusId={verliererseiteModusId}
                verliererseiteFirstToLegs={verliererseiteFirstToLegs}
                verliererseiteStartpunkte={verliererseiteStartpunkte}
                gewinnerseiteSets={gewinnerseiteSets}
                gewinnerseiteModusId={gewinnerseiteModusId}
                gewinnerseiteFirstToLegs={gewinnerseiteFirstToLegs}
                gewinnerseiteStartpunkte={gewinnerseiteStartpunkte}
                setGewinnerseiteSets={setGewinnerseiteSets} setGewinnerseiteFirstToLegs={setGewinnerseiteFirstToLegs} setGewinnerseiteModusId={setGewinnerseiteModusId} setGewinnerseiteStartpunkte={setGewinnerseiteStartpunkte}
                setVerliererseiteSets={setVerliererseiteSets} setVerliererseiteFirstToLegs={setVerliererseiteFirstToLegs} setVerliererseiteModusId={setVerliererseiteModusId} setVerliererseiteStartpunkte={setVerliererseiteStartpunkte}
                aufnahmenBisBullen={aufnahmenBisBullen} setAufnahmenBisBullen={setAufnahmenBisBullen}
                bullenDisabled={istTurnierAbgeschlossen()}
            />
            <div style={{color:"red", marginTop:20}}>Weitere Einstellungen, z.B. zu den einzelnen Spielrunden, kannst du nach der Auslosung in der Listenansicht hinter dem jeweiligen Bereich oder im Baum durch Klick auf die Überschrift vornehmen.</div>
        </>
    }

    function getCricketArea() {
        if (tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id || tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id) {
            return <TournamentCricketArea showSets={true} showBestOfLegs={true} showPflichtfelder={true}
                                          sets={gewinnerseiteSets} firstToLegs={gewinnerseiteFirstToLegs}
                                          bestOfLegs={gewinnerseiteBestToLegs}
                                          zufallszahlen={gewinnerseiteZufallszahlen}
                                          zufallszahlenjedesleg={gewinnerseiteZufallszahlenJedesLeg}
                                          cutthroat={gewinnerseiteCutthroat}
                                          onSetsChanged={(sets) => setGewinnerseiteSets(sets)}
                                          onFirstToLegsChanged={(firstToLegs) => setGewinnerseiteFirstToLegs(firstToLegs)}
                                          onBestOfLegsChanged={(bestOfLegs) => setGewinnerseiteBestToLegs(bestOfLegs)}
                                          onZufallszahlenChanged={(value) => setGewinnerseiteZufallszahlen(value)}
                                          onZufallszahlenjedeslegChanged={(value) => setGewinnerseiteZufallszahlenJedesLeg(value)}
                                          onCutthroatChanged={(value) => setGewinnerseiteCutthroat(value)}/>
        }
        return <KODKOCricketVerwaltenArea
            tournamentSystem={tournamentSystem}
            gewinnerseiteSets={gewinnerseiteSets} gewinnerseiteFirstToLegs={gewinnerseiteFirstToLegs} gewinnerseiteZufallszahlen={gewinnerseiteZufallszahlen} gewinnerseiteZufallszahlenJedesLeg={gewinnerseiteZufallszahlenJedesLeg} gewinnerseiteCutthroat={gewinnerseiteCutthroat}
            verliererseiteSets={verliererseiteSets} verliererseiteFirstToLegs={verliererseiteFirstToLegs} verliererseiteZufallszahlen={verliererseiteZufallszahlen} verliererseiteZufallszahlenJedesLeg={verliererseiteZufallszahlenJedesLeg} verliererseiteCutthroat={verliererseiteCutthroat}
            setGewinnerseiteSets={setGewinnerseiteSets} setGewinnerseiteFirstToLegs={setGewinnerseiteFirstToLegs} setGewinnerseiteZufallszahlen={setGewinnerseiteZufallszahlen} setGewinnerseiteZufallszahlenJedesLeg={setGewinnerseiteZufallszahlenJedesLeg} setGewinnerseiteCutthroat={setGewinnerseiteCutthroat}
            setVerliererseiteSets={setVerliererseiteSets} setVerliererseiteFirstToLegs={setVerliererseiteFirstToLegs} setVerliererseiteZufallszahlen={setVerliererseiteZufallszahlen} setVerliererseiteZufallszahlenJedesLeg={setVerliererseiteZufallszahlenJedesLeg} setVerliererseiteCutthroat={setVerliererseiteCutthroat}
        />
    }

    return <DHDialog onClose={callBackOnClose} title="Gruppe / KO / DKO Turnier / Kratzer / Schweizer anlegen/bearbeiten" buttons={dialogFooter} showCloseButton={true} comp={<>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall id="id-bezeichnung" width={350} label="Bezeichnung" required={true} disabled={istTurnierAbgeschlossen()} value={bezeichnung}
                              onChange={(text) => setBezeichnung(text)}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall id="id-kurzezeichnung" width={350} label="Bezeichnung(kurz)" required={true} disabled={istTurnierAbgeschlossen()} value={bezeichnungShort}
                              onChange={(text) => setBezeichnungShort(text)}/>
        </div>
        <div style={{marginBottom: 20}}>
            <DHDateTimePicker disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={beginn} changeValue={setBeginn} label="Startzeitpunkt *"/>
            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
               onClick={(e) => setShowStartzeitpunktNotice(!showStartzeitpunktNotice)}/>
            <DHDefaultDrawer onClose={() => setShowStartzeitpunktNotice(false)} show={showStartzeitpunktNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Sofern du keine Uhrzeit angeben möchtest, wähle bitte 00:00 für die Uhrzeit aus. In diesem Fall werden wir dem Benutzer/Teilnehmer die Uhrzeit nicht anzeigen. Alle anderen
                        Uhrzeiten werden dem Benutzer/Teilnehmer zusätzlich zum Datum angezeigt.
                    </div>
                </div>
            }/>
        </div>
        <div className="grid">
            <div className="col-fixed" style={{width: 140, color: tournamentSystem === undefined || tournamentSystem === null ? "red" : ""}}>Turniermodus: *</div>
            <div className="col">
                <SelectButton disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={tournamentSystem}
                              optionLabel="name"
                              options={turniersystemsAuswahl}
                              onChange={(e) => {
                                  setTournamentSystem(e.value);
                              }}></SelectButton>
            </div>
        </div>
        <div className="grid">
            <DHDefaultDrawer onClose={() => setShowDartTypeNotice(false)} show={showDartTypeNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Dart-Type wird im öffentlichen Bereich angezeigt.
                    </div>
                    <div style={{marginBottom: 5}}>
                        Bei Events von einem Veranstalter ist die richtige Auswahl wichtig, da der Scorer damit gesteuert wird ob E-Dart (Legeingabe) oder Scoring mit dem Scorer möglich ist.
                    </div>
                </div>
            }/>
            <div className="col-fixed" style={{width: 140}}>Dart-Typ:
                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                   onClick={(e) => setShowDartTypeNotice(!showDartTypeNotice)}/>
            </div>
            <div className="col">
                <SelectButton optionLabel="name" value={dartType} options={darttypes} onChange={(e) => setDartType(e.value)}
                              disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
            </div>
        </div>

        <TabView style={{width: "100%", paddingTop: 10, paddingLeft: 10, paddingRight: 10, border: "none"}}>
            <TabPanel header="Modus">
                <div className="grid" style={{textAlign: "left"}}>
                    <div className="flex align-items-center justify-content-center h-4rem"
                         style={{marginLeft: 5, marginRight: 5}}>
                        <ToggleButton style={{width: 200}} checked={gameType === 'x01'} offLabel="X01" onLabel="X01"
                                      onChange={(e) => setGameType('x01')}
                                      className={istTurnierGestartet() || istTurnierAbgeschlossen() ? "p-disabled" : ""}/>
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <ToggleButton style={{width: 200}} checked={gameType === 'cricket'} offLabel="Cricket"
                                          onLabel="Cricket" onChange={(e) => setGameType('cricket')}
                                          className={istTurnierGestartet() || istTurnierAbgeschlossen() ? "p-disabled" : ""}/>
                        }
                    </div>
                </div>
                {gameType === "x01" && getX01Area()}
                {gameType === "cricket" && getCricketArea()}
            </TabPanel>
            <TabPanel header="Optionale Eingaben">
                <div className="grid">
                    <div className="col-fixed" style={{width: 200}}>Beschreibung:</div>
                </div>
                <div className="grid">
                    <div className="col" style={{width: "100%"}}>
                        <InputTextarea rows={5} cols={50} maxLength={10000} value={beschreibung}
                                       onChange={(e) => setBeschreibung(e.target.value)}/>
                    </div>
                </div>
                {eventOperatorId !== undefined && eventOperatorId !== null && <>
                    <hr/>
                    {(id === null || id === undefined) && <div>Bestleistungen können erst nach dem ersten Speichern eines Turniers festgelegt werden.</div>}
                    <div>
                        <DHButtonDefault label="Bestleistungen bearbeiten" disabled={id === null || id === undefined} onClick={() => setShowBestleistungenDialog(true)}/>
                    </div>
                </>
                }
                {eventOperatorId !== undefined && eventOperatorId !== null &&
                    (TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id === tournamentSystem ||
                        TOURNAMENTSYSTEMS.KRATZER.id === tournamentSystem ||
                        TOURNAMENTSYSTEMS.EINFACHERKO.id === tournamentSystem ||
                        TOURNAMENTSYSTEMS.DOPPELTERKO.id === tournamentSystem ||
                        TOURNAMENTSYSTEMS.ROUND_ROBIN.id === tournamentSystem) && <>
                        <div style={{marginTop: 10}}>Rangliste:</div>
                        <div><RanglisteComponent eventOperatorId={eventOperatorId} onChange={(id) => setRanglisteId(id)} ranglisteId={ranglisteId} onError={(message) => setErrorMessage(message)}/>
                        </div>
                        <div style={{marginTop: 10}}>Ranglistenprofil:</div>
                        <div><RanglisteProfilesComponent eventOperatorId={eventOperatorId} onChange={(id) => setRanglisteProfileId(id)} ranglisteProfileId={ranglisteProfileId}
                                                         onError={(message) => setErrorMessage(message)}/></div>
                    </>
                }
                {eventOperatorId !== undefined && eventOperatorId !== null &&
                    (TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id === tournamentSystem ||
                        TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id === tournamentSystem) && <>
                        <div style={{marginTop: 10}}>Rangliste:</div>
                        <div><RanglisteComponent eventOperatorId={eventOperatorId} onChange={(id) => setRanglisteId(id)} ranglisteId={ranglisteId} onError={(message) => setErrorMessage(message)}/>
                        </div>
                        <div style={{marginTop: 10}}>Ranglistenprofil Gold-Turnier: <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                                                                       onClick={(e) => setShowGoldSilberRanglistenprofilNotice(!showGoldSilberRanglistenprofilNotice)}/></div>
                        <div><RanglisteProfilesComponent eventOperatorId={eventOperatorId} onChange={(id) => setRanglisteProfileId(id)} ranglisteProfileId={ranglisteProfileId}
                                                         onError={(message) => setErrorMessage(message)}/></div>
                        <div style={{marginTop: 10}}>Ranglistenprofil Silber-Turnier: <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                                                                         onClick={(e) => setShowGoldSilberRanglistenprofilNotice(!showGoldSilberRanglistenprofilNotice)}/></div>
                        <div><RanglisteProfilesComponent eventOperatorId={eventOperatorId} onChange={(id) => setRanglisteProfileIdSilber(id)} ranglisteProfileId={ranglisteProfileIdSilber}
                                                         onError={(message) => setErrorMessage(message)}/></div>
                        <div style={{marginTop: 10}}>Ranglistenprofil Bronze-Turnier: <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                                                                         onClick={(e) => setShowGoldSilberRanglistenprofilNotice(!showGoldSilberRanglistenprofilNotice)}/></div>
                        <div><RanglisteProfilesComponent eventOperatorId={eventOperatorId} onChange={(id) => setRanglisteProfileIdBronze(id)} ranglisteProfileId={ranglisteProfileIdBronze}
                                                         onError={(message) => setErrorMessage(message)}/></div>
                        <div style={{marginTop: 10}}>Ranglistenprofil Gruppen-Phase: <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                                                                        onClick={(e) => setShowGoldSilberRanglistenprofilNotice(!showGoldSilberRanglistenprofilNotice)}/></div>
                        <div><RanglisteProfilesComponent eventOperatorId={eventOperatorId} onChange={(id) => setRanglisteProfileIdGruppe(id)} ranglisteProfileId={ranglisteProfileIdGruppe}
                                                         onError={(message) => setErrorMessage(message)}/></div>
                        <DHDefaultDrawer onClose={() => setShowGoldSilberRanglistenprofilNotice(false)} show={showGoldSilberRanglistenprofilNotice} title={"Hinweis"} children={
                            <div style={{padding: 20}}>
                                <div style={{marginBottom: 5}}>
                                    Nach einem Gruppenturnier kann ein Gold-Turnier (früher Folgeturnier), ein Silber-Turnier (früher Lucky Loser) und oder ein Bronze-Turnier gespielt werden.<br/>
                                    Das Bronze- und Silber-Turnier ist optional, wobei das Gold-Turnier in dieser Turnierform normal immer gespielt wird.<br/><br/>
                                    Für alle drei Turniere kann es ein unterschiedliches Ranglistenprofil geben und damit unterschiedliche Punkte.<br/>
                                    Hier gehen wir nur auf Silber-Gold ein, Bronze verhält sich nätürlich genauso.<br/>
                                    Sofern du im Silber-Turnier keine Punkte vergeben willst, vergebe einfach kein Ranglistenprofil dafür.<br/><br/><br/>
                                    Zusätzlich kannst du noch Ranglistenprofil Gruppen-Phase vergeben.<br/><br/>
                                    Beispiel 1:<br/>
                                    Du vergibst ein Profil für die Gruppenphase, der Spieler wird z.B. 2ter. Damit erhält er aus der Gruppenphase z.B. 5 Punkte.<br/>
                                    Mit dem zweiten Platz kommt er in das Gold-Turnier und gewinnt dieses. Damit erhält er z.B. 20 Punkte.<br/>
                                    Für die Anwesenheit hast du 3 Punkte an der Rangliste konfiguriert.<br/>
                                    Somit erhält der Spieler 5+20+3=28 Punkte.<br/><br/>
                                    Beispiel 2:
                                    Durch das Ranglistenprofil der Gruppenphase erhält der Spieler für Platz 3 z.B. 7 Punkte.<br/>
                                    Mit dem dritten Platz kommt der Spieler in das Silber-Turnier und da bis ins Halbfinale.<br/>
                                    Über das Ranglisten-Profil für das Silber-Turnier erhält er somit 10 Punkte.<br/>
                                    Es gibt für dieses Beispiel keine Anwesenheitspunkte.<br/>
                                    Der Spieler erhält 0+10+7=17 Punkte.<br/><br/>
                                    Beispiel 3:
                                    Der Spieler belegt in der Gruppenphase Platz 2 und kommt ins Gold-Turnier.<br/>
                                    Für die Gruppenphase ist kein Ranglistenprofil hinterlegt.<br/>
                                    Im Gold-Turnier erhält er für Platz 5 z.B. 6 Punkte.<br/>
                                    Es gibt keine Anwesenheitspunkte.<br/>
                                    Der Spieler erhält ausschließich für die Punkte aus dem Gold-Turnier und damit 6 Punkte.<br/>

                                </div>
                            </div>
                        }/>
                    </>
                }
                <hr/>
                <div className="grid">
                    <div className={"col-12 md:col-12 lg:col-12"} style={{padding: 10}}>
                        <div style={{marginBottom: 10}}>
                            <DHDefaultDrawer onClose={() => setShowKennwortNotice(false)} show={showKennwortNotice} title={"Hinweis"} children={
                                <div style={{padding: 20}}>
                                    <div style={{marginBottom: 5}}>Die Eingabe des Kennworts ist optional. Sobald ein
                                        Kennwort angegeben wird, muss der Benutzer bei
                                        der Teilnahme ein Kennwort eingeben.
                                    </div>
                                </div>
                            }/>
                            <div style={{display: "flex", alignContent: "center", alignItems: "center"}}>
                                <DHTextFieldSmall id="id-kennwort" width={200} value={kennwort} onChange={(text) => setKennwort(text)} label="Kennwort für Eventteilnahme"
                                                  disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
                                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                   onClick={(e) => setShowKennwortNotice(!showKennwortNotice)}/>
                            </div>
                        </div>
                        <hr/>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-minanzahlteilnehmer" variant="standard" width={200} value={minimaleAnzahlTeilnehmer}
                                               onChange={(text) => setMinimaleAnzahlTeilnehmer(text)} label="Minimale Teilnehmerzahl"
                                               min={0} max={1024}
                                               disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-maxanzahlteilnehmer" variant="standard" width={200} value={maximaleAnzahlTeilnehmer}
                                               onChange={(text) => setMaximaleAnzahlTeilnehmer(text)} label="Maximale Teilnehmerzahl"
                                               min={0} max={1024}
                                               disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHSwitch id="id-warteliste" onChange={() => setPlayerWarteliste(!playerWarteliste)} value={playerWarteliste}
                                      label="Warteliste aktiv"
                                      disabled={istTurnierAbgeschlossen() || maximaleAnzahlTeilnehmer === null || maximaleAnzahlTeilnehmer === undefined}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHDateTimePicker label="Anmeldeende" disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={anmeldeende} changeValue={setAnmeldeende}/>
                        </div>
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div style={{marginBottom: 10}}>
                                <DHDateTimePicker label="Anzeigen ab" disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={anzeigenAb} changeValue={setAnzeigenAb}/>
                            </div>
                        }
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div className="grid">
                                <DHDefaultDrawer onClose={() => setShowMaxAverageNotice(false)} show={showMaxAverageNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>Als Avg. wird die 60 Tage Average des Spielers genommen.
                                        </div>
                                    </div>
                                }/>
                                <div className="col-fixed" style={{width: 210}}>Average Obergrenze:
                                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                       onClick={(e) => setShowMaxAverageNotice(!showMaxAverageNotice)}/>
                                </div>
                                <div className="col">
                                    <InputNumber value={averageObergrenze}
                                                 style={{width: 200}}
                                                 disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}
                                                 onChange={(e) => setAverageObergrenze(e.value)}
                                                 mode="decimal" locale="de-DE" minFractionDigits={2}/>
                                </div>
                            </div>
                        }
                        {tournamentSystem === TOURNAMENTSYSTEMS.EINFACHERKO.id &&
                            <div style={{marginBottom: 10}}>
                                <DHSwitch id="id-spielumplatz3" onChange={() => setSpielUmPlatz3(!spielUmPlatz3)} value={spielUmPlatz3}
                                          label="Spiel um Platz 3"
                                          disabled={istTurnierAbgeschlossen()}/>
                            </div>
                        }
                        {tournamentSystem === TOURNAMENTSYSTEMS.DOPPELTERKO.id &&
                            <div style={{marginBottom: 10}}>
                                <DHSwitch id="id-finalesatzausgleich" onChange={() => setFinaleVerliererseiteMussZweiSpieleGewinnen(!finaleVerliererseiteMussZweiSpieleGewinnen)}
                                          value={finaleVerliererseiteMussZweiSpieleGewinnen}
                                          label="Final Satzausgleich"
                                          disabled={istTurnierAbgeschlossen()}/>
                            </div>
                        }
                        {(tournamentSystem === TOURNAMENTSYSTEMS.EINFACHERKO.id || tournamentSystem === TOURNAMENTSYSTEMS.DOPPELTERKO.id) &&
                            <div style={{marginBottom: 10}}>
                                <DHDefaultDrawer onClose={() => setShowStartTournamentNotice(false)} show={showStartTournamentNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>Turnier wird am Startzeitpunkt automatisch gestartet
                                        </div>
                                    </div>
                                }/>
                                {(eventOperatorId === null || eventOperatorId === undefined) && <>
                                    <DHSwitch id="id-sollvomsystemgestartetwerden" onChange={() => setSollVomSystemGestartetWerden(!sollVomSystemGestartetWerden)} value={sollVomSystemGestartetWerden}
                                              label="Turnier automatisch starten"
                                              disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
                                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                       onClick={(e) => setShowStartTournamentNotice(!showStartTournamentNotice)}/>
                                </>
                                }
                            </div>
                        }
                        <div style={{marginBottom: 10}}>
                            <DHSwitch id="id-doppelturnier" onChange={() => setDoppelturnier(!doppelturnier)} value={doppelturnier}
                                      label="Doppelturnier"
                                      disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
                        </div>
                        {eventOperatorId !== null && eventOperatorId !== undefined && doppelturnier &&
                            <div style={{marginBottom: 10}}>
                                <DHDefaultDrawer onClose={() => setShowDypNotice(false)} show={showDypNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>DYP (Draw Your Partner) bezeichnet die Zuteilung von Spielpartnern per Los.
                                            Es melden sich Einzelspieler am Turnier an. Die Zuteilung der Doppelpartner erfolgt vom System.
                                            Beim Turnierstart muss eine gerade Anzahl an Spielern im System vorhanden sin.
                                        </div>
                                    </div>
                                }/>
                                <DHSwitch id="id-doppelturnier" onChange={() => setDyp(!dyp)} value={dyp}
                                          label="DYP"
                                          disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
                                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                   onClick={() => setShowDypNotice(!showDypNotice)}/>
                            </div>
                        }
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div style={{marginBottom: 10}}>
                                <DHDefaultDrawer onClose={() => setShowUrkundenNotice(false)} show={showUrkundenNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>Für abgeschlossene Ligen können Urkunden generiert
                                            werden, hierfür musst du einen 'Urkundenrohlung' mit dem Admin vereinbaren und
                                            los
                                            gehts.
                                        </div>
                                    </div>
                                }/>
                                <DHSwitch id="id-urkundengenerierung" onChange={() => setUrkundendruck(!urkundendruck)} value={urkundendruck}
                                          label="Urkundengenerierung"
                                          disabled={istTurnierAbgeschlossen()}/>
                                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                   onClick={(e) => setShowUrkundenNotice(!showUrkundenNotice)}/>
                            </div>
                    }
                    {(eventOperatorId === undefined || eventOperatorId === null) && <>
                        <div style={{marginBottom: 10}}>
                            <DHDefaultDrawer onClose={() => setShowRanglisteNotice(false)} show={showRanglisteNotice} title={"Hinweis"} children={
                                <div style={{padding: 20}}>
                                    <div style={{marginBottom: 5}}>Sofern du das Turnier als Rangliste markierst, wird
                                        diese
                                        bei der Ranglistenberechnung berücktsichtigt.
                                    </div>
                                    <div style={{marginBottom: 5}}>Achtung!!! Du musst Ranglistenpunkte im System
                                        definieren. Bei Fragen melde dich in der Facebookgruppe https://www.facebook.com/groups/darthelfer oder wende dich an den Admin.
                                    </div>
                                </div>
                            }/>
                            <DHSwitch id="id-rangliste" onChange={() => setRangliste(!rangliste)} value={rangliste}
                                      label="Rangliste"
                                      disabled={istTurnierAbgeschlossen()}/>
                            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                               onClick={() => setShowRanglisteNotice(!showRanglisteNotice)}/>
                        </div>
                        {rangliste &&
                            <div className="grid">
                                <div className="col-fixed" style={{width: 210}}>Markers:</div>
                                <div className="col-fixed" style={{width: "200px"}}>
                                    <RanglisteMarkerComponent eventOperatorId={eventOperatorId}
                                                              onValueChange={(markers) => setRanglistemarkers(markers)}
                                                              selectedMarkers={ranglistemarkers}/>
                                </div>
                            </div>
                        }
                    </>
                    }
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Veranstalter" disabled={eventOperatorId === null || eventOperatorId === undefined}>
                <div className="grid">
                <div className="col-12 md:col-12 lg:col-6">
                        <EventVeranstalterZusatzdatenComp eventOperatorId={eventOperatorId}
                                                          isEventGestartet={istTurnierGestartet()}
                                                          isEventAbgeschlossen={istTurnierAbgeschlossen()}
                                                          publishTournament={publishTournament}
                                                          online={online}
                                                          scoringWithDarthelfer={scoringWithDarthelfer}
                                                          anwesenheitspruefungScorer={anwesenheitspruefungScorer}
                                                          registrationAllowed={registrationAllowed}
                                                          deleteUnconfirmedRegistrations={deleteUnconfirmedRegistrations}
                                                          bezahlung={bezahlung}
                                                          bezahlungbetrag={bezahlungbetrag}
                                                          participantsMailConfirmation={participantsMailConfirmation}
                                                          mailtext={mailtext}
                                                          onPublishTournament={() => setPublishTournament(!publishTournament)}
                                                          onOnline={() => setOnline(!online)}
                                                          onScoringWithDarthelfer={() => {
                                                              // ohne Scorer gibt es keine Anwesenheitsprüfung am Scorer
                                                              if (scoringWithDarthelfer) {
                                                                  setAnwesenheitspruefungScorer(false);
                                                              }
                                                              setScoringWithDarthelfer(!scoringWithDarthelfer);
                                                          }}
                                                          onAnwesenheitspruefungScorer={() => setAnwesenheitspruefungScorer(!anwesenheitspruefungScorer)}
                                                          onRegistrationAllowed={() => setRegistrationAllowed(!registrationAllowed)}
                                                          onDeleteUnconfirmedRegistrations={() => setDeleteUnconfirmedRegistrations(!deleteUnconfirmedRegistrations)}
                                                          onParticipantsMailConfirmation={() => setParticipantsMailConfirmation(!participantsMailConfirmation)}
                                                          onBezahlung={() => setBezahlung(!bezahlung)}
                                                          onBezahlungbetrag={(text) => setBezahlungbetrag(text)}
                                                          onMailtext={(text) => setMailtext(text)}
                        />
                    </div>
                    {!isFolgeturnier() &&
                    <div className="col-12 md:col-12 lg:col-6">
                        <EventVeranstalterAusrichterDatenComp
                            eventOperatorId={eventOperatorId}
                            onError={(text) => setErrorMessage(text)}
                            austragungsortTelefon={austragungsortTelefon} onChangeAustragungsortTelefon={(text) => setAustragungsortTelefon(text)}
                            austragungsortEmail={austragungsortEmail} onChangeAustragungsortEmail={(text) => setAustragungsortEmail(text)}
                            socialmedia={socialmedia} onChangeSocialmedia={(text) => setSocialmedia(text)}
                            homepage={homepage} onChangeHomepage={(text) => setHomepage(text)}
                            isEventAbgeschlossen={istTurnierAbgeschlossen()}
                            isAustragungsortPflicht={isAustragungsortPflicht()}
                            austragungsortBezeichnung={austragungsortBezeichnung} onChangeAustragungsortBezeichnung={(text) => setAustragungsortBezeichnung(text)}
                            austragungsortStrasse={austragungsortStrasse} onChangeAustragungsortStrasse={(text) => setAustragungsortStrasse(text)}
                            austragungsortPLZ={austragungsortPLZ} onChangeAustragungsortPLZ={(text) => setAustragungsortPLZ(text)}
                            austragungsortOrt={austragungsortOrt} onChangeAustragungsortOrt={(text) => setAustragungsortOrt(text)}
                        />
                    </div>
                    }
                </div>
            </TabPanel>
            {eventOperatorId !== null && eventOperatorId !== undefined && tournamentSystem === TOURNAMENTSYSTEMS.KRATZER.id &&
                <TabPanel header="Kratzer">
                    <TurnierKratzerTabPanel onError={(message) => setErrorMessage(message)}
                                            tournamentId={id}/>
                </TabPanel>
            }
            {(eventOperatorId === null || eventOperatorId === undefined) &&
                <TabPanel header="Admins">
                    <TurnierAdminTabPanel changeAdmins={(admins) => setAdmins(admins)}
                                          onError={(message) => setErrorMessage(message)} admins={admins}/>
                </TabPanel>
            }
            {(eventOperatorId === null || eventOperatorId === undefined) &&
                <TabPanel header="Sponsoren">
                    <TurnierSponsorenTabPanel onError={(message) => setErrorMessage(message)} sponsoren={sponsoren}
                                              changeSponsoren={(sponsoren) => setSponsoren(sponsoren)}/>
                </TabPanel>
            }
            <TabPanel header="Aktionen" disabled={id === undefined}>
                <LigaAktionenComponent proTournament={tournament} onInfo={(message) => setInfoMessage(message)}
                                       onClose={() => ""}
                                       callBackLoadNewTournament={(newId) => {
                                           ladeTurnier(newId);
                                           callBackRefresh();
                                       }}
                                       callBackRefresh={() => {
                                           ladeTurnier(id);
                                           callBackRefresh();
                                       }}
                                       callBackCloseDialog={() => {
                                           callBackOnClose();
                                       }}
                                       callBackOnDelete={() => {
                                           callBackOnDelete();
                                       }}
                                       onClearMessages={() => setErrorMessage(undefined)}
                                       onError={(message) => setErrorMessage(message)}/>
            </TabPanel>
            {id !== undefined &&
                <TabPanel header="QRCodes">
                    <TurnierQRCode tournamentId={id} eventOperatorId={eventOperatorId} onlineTournament={online} tournamentSystem={tournamentSystem} bezeichnung={bezeichnung}/>
                </TabPanel>
            }
        </TabView>
        {showPublishTournamentInfo && <InfoDialogEventNichtVeroeffentlichen onClose={() => setShowPublishTournamentInfo(false)}/>}
        {showBestleistungenDialog && <BestleistungenDialog onClose={() => setShowBestleistungenDialog(false)} tournamentId={id}/>}
        <div style={{marginTop: 20, fontSize: 10}}>TurnierId: {id}</div>
    </>}/>
}

TurnierVerwaltenDialog.propTypes = {
    callBackOnClose: PropTypes.func.isRequired,
    callBackRefresh: PropTypes.func.isRequired,
    tournamentId: PropTypes.string,
    propEventOperatorId: PropTypes.string,
};

export default TurnierVerwaltenDialog
